import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-start-survey-overlay',
    templateUrl: './start-survey-overlay.component.html',
    styleUrls: ['./start-survey-overlay.component.scss'],
    imports: [TranslatePipe]
})
export class StartSurveyOverlayComponent {

    readonly openSurvey = output<void>();

    constructor() {
    }

    startSurvey() {
        this.openSurvey.emit();
    }
}
